import React from "react";
import "./EmpEquipment.css";
import EmpHeader from "./sub-Employee/EmpHeader";
import EmpContent from "./sub-Employee/EmpContent";

function EmpEquipment (item) {
    return(
        <div className="container mainactualemp">
            <div className="row">
            <div className="col-12 ActuaEmp" >
                    <EmpHeader emptitle={"Actual Equipments"}/>
                    <EmpContent />
                </div>
            </div>
        </div>
    )
};

export default EmpEquipment ;